import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import useParams from '@components/Hooks/useParams';
import useSiteConfig from '@components/Hooks/useSiteConfig';
import React, { useEffect, useState } from 'react';
import Widget from './Widget';

interface Props {
  size: 'sm' | 'md' | 'lg' | undefined,
}


const Widgets: React.FC<Props> = (props) => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const params = useParams();
  const [required, setRequired] = useState<Array<string>>([]);
  const site_config = useSiteConfig();

  useEffect(() => {
    if (site_config) {
      api.getWidgets(site_config.domain);
    }
  }, [site_config]);

  // useEffect(() => {
  //   if (site_config && store.apps && store.manage) {
  //     api.getWidgets(site_config.domain);
  //   }
  // }, [site_config, store.apps, store.manage]);

  useEffect(() => {
    store.widgets?.some((widget) => {
      if (widget.required && required.indexOf(widget.name) < 0) {
        const req = required.concat([]);
        req.push(widget.name);
        setRequired(req);
        location.replace('#/widget/' + widget.name);
        return true;
      }
      return false;
    });
  }, [store.widgets]);

  return (
    <div className={'widget-container-' + (props.size ?? 'sm')} style={{ marginTop: 7, columnGap: 0 }}>
      {store.widgets?.map((widget, idx) => {
        return (
          <Widget key={widget.id} widget={widget} idx={idx} active={params.widget == widget.name} />
        )
      })}
    </div>
  );
}

export default Widgets;